var handleFileUpload = function handleFileUpload() {
  var formUpload = document.querySelector('[data-component="fileUpload"]');
  if (formUpload) {
    var fileInput = formUpload.querySelector('[data-element="fileUploadInput"]');
    var body = document.querySelector('body');
    var uploadFileOnInputChange = function uploadFileOnInputChange() {
      var formData = new FormData();
      formData.append('file', fileInput.files[0]);
      formData.append(window.csrfTokenName, window.csrfTokenValue);
      if (fileInput.files.length === 0) {
        fileInput.closest('.input').classList.add('has-error');
      } else {
        body.classList.add('is-loading');
        fetch('/actions/nlr/my-documents/file', {
          method: 'POST',
          body: formData
        }).then(function (response) {
          if (response.ok) {
            window.location.reload();
            body.classList.remove('is-loading');
          }
        })["catch"](function (error) {
          console.log(error);
        });
      }
    };
    fileInput.addEventListener('change', uploadFileOnInputChange);
  }
};
handleFileUpload();